import { createRootRoute, Link, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary'
import { AuthProvider } from '../lib/AuthContext'

export const Route = createRootRoute({
  component: () => (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  ),
  errorComponent: ({ error, reset }) => (
    <ErrorBoundary error={error} reset={reset} />
  ),
})
